var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "section",
        { staticClass: "cont", staticStyle: { "padding-top": "120px" } },
        [
          _c("div", { staticClass: "icon icon64 idtroc-sade" }),
          _vm._v(" "),
          _c("p", { staticClass: "centered" }, [
            _vm._v(
              "\n      Cette page n'existe pas ou a été supprimée,\n      "
            ),
            _c("br"),
            _vm._v("rendez-vous sur notre page d'accueil !\n    ")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a12e54e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a12e54e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = null
// module chunks = 